<!-- chat container -->
<div class="chatContainer">

    <!-- top bar chat -->
    <div class="pd05 border-b" fxLayoutAlign="space-between center">
        <span class="ft500 ft14 gray-9">Chat de ayuda </span>
        <div>
            <a href="https://web.whatsapp.com/send?phone=529932872551" target="_blank" >
                <mat-icon class="mgl05 ft18 linkIcon cursorPointer gray-9" (click)="cerrarChat()">phone</mat-icon>
            </a>
            <mat-icon class="mgl10 ft18 linkIcon cursorPointer gray-9" (click)="cerrarChat()">close</mat-icon>
        </div>
    </div>

    <!-- messages -->
    <div class="messagesContainer" id="messagesContainer">
        {{scrollDown()}}
        <div class="pd05">
            <p class="ft11 lineHeight100">
                Envianos tu consulta. El equipo de soporte de Predyc atenderá tu solicitud a la brevedad posible.  
            </p>
        </div>
        <div *ngFor="let item of chat; let i = index" class="recievedMessage" [ngClass]="{'sentMessage':item.admin == false}">
            <div class="message">
                <span class="ft9 gray-6 mgb03"> {{item.date}} </span>
                <span class="ft11 lineHeight100 mgb03">{{item.mensaje}}</span>
            </div>
            <span *ngIf="i == chat.length-1 && item.admin == false" class="ft9 mgl05 mgr05">{{item.leido}}</span>
        </div>
    </div>

    <!-- message box input -->
    <div class="pdl05 pdr05 pdt05 pdb0 shadow16">
        <textarea [(ngModel)]="mensaje" type="text" class="fw h50px ft11" placeholder="Escribe tu mensaje aqui"
            (keyup.enter)="enviarMensaje()"></textarea>
    </div>
</div>